import { jsxs as e, Fragment as C, jsx as l } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ e(C, { children: [
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.25 2C5.00736 2 4 3.00736 4 4.25V19.25C4 20.4926 5.00736 21.5 6.25 21.5H17.25C18.4926 21.5 19.5 20.4926 19.5 19.25V6H15V2H6.25ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V14.5858L9.70711 13.2929C9.31658 12.9024 8.68342 12.9024 8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071L11.2929 17.7071C11.6834 18.0976 12.3166 18.0976 12.7071 17.7071L15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929C15.3166 12.9024 14.6834 12.9024 14.2929 13.2929L13 14.5858V9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      d: "M18.9138 3.91376C19.2105 4.21053 19.4047 4.59123 19.4728 5H16V2H16.1716C16.702 2 17.2109 2.21094 17.586 2.58601L18.9138 3.91376Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
